import * as yup from 'yup'

// Enums
export const enum ArbitrationState {
  NEW = 1,
  SUBMITTED = 2,
  EXPIRED = 3
}

export const enum IssueTypes {
  PHYSICAL_DAMAGE = 1,
  NON_PHYSICAL_DAMAGE = 2
}

export const enum ContactMethods {
  EMAIL = 1,
  PHONE = 2
}

export const enum ResolutionTypes {
  ADJUSTMENT = 1,
  BUYBACK = 2
}

// API Response Types
export interface IGetArbitrationMetadataResponse {
  FileSizeLimit: number
  AttachmentFormats: string[]
  MaximumMileageExceed: number
  MaxDocumentCount: number
  PhysicalDamageMinDocuments: number
  NonPhysicalDamageMinDocuments: number
  AttachmentsDisabled: boolean
  ContactMethods: IDropdownItem[]
  IssueTypes: IDropdownItem[]
  ResolutionTypes: IDropdownItem[]
}

export interface IGetArbitrationInfoResponse {
  SaleInformation: ISaleInformation
  ContactInformation: IContactInformation
  ArbitrationInformation: IArbitrationInformation
}

export interface IArbitrationInformationRequest {
  VehicleInstanceID: number
  BuyerVehiclePurchaseID: number
  ContactName: string
  ContactEmail: string
  PhoneNumber: string
  ContactMethodID: number
  IssueTypeID: number
  ResolutionTypeID: number
  CurrentMileage: number
  Reason: string
  Documents: IDocumentSubmit[]
  VIN: string
}

export interface IArbitrationDocumentRequest {
  VehicleInstanceID: number
  ArbitrationID: number
  SalesforceCaseID: string
  VIN: string
  Documents: IDocumentSubmit[]
}

export interface ISaleInformation {
  VIN: string
  ModelYear: string
  Model: string
  Mileage: number
  MileageString: string
  Grade: string
  SalePrice: number
  SalePriceString: string
  SaleDate: Date
  Announcements: string[]
}

export interface IContactInformation {
  ContactName: string
  ContactEmail: string
  PhoneNumber: string
  ContactMethodID: number
}

export interface IArbitrationInformation {
  ArbitrationID: number
  SalesforceCaseID: string
  IssueTypeID: number
  ResolutionTypeID: number
  IssueTypeDescription: string
  ResolutionTypeDescription: string
  CurrentMileage: number
  Reason: string
  Documents: IArbitrationDocumentInfo[]
}

export interface IDropdownItem {
  ID: number
  Description: string
}

export interface IArbitrationDocumentInfo {
  ID: number
  FileName: string
}

export interface IDocumentSubmit {
  FileName: string
  FileContent: string
}

export interface IArbitrationRequest {
  vehicleInstanceID: number
  buyerVehiclePurchaseID: number
}

export interface IArbitrationResult {
  State: ArbitrationState
}

// Form Types
export interface IArbitrationForm {
  name: string
  email: string
  phoneNumber: string
  contactMethodID: number
  issueTypeID: number
  resolutionTypeID: number
  currentMileage: string
  reasonForArbitration: string
  documents: IDocumentSubmit[]
}

const phoneRegex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/
const mileageRegex = /^[0-9]+$/

export const arbitrationFormSchema = yup.object({
  name: yup.string().trim().required('Name is required'),
  email: yup.string().trim().email('Email address format is not correct').required('Email is required'),
  phoneNumber: yup
    .string()
    .trim()
    .matches(phoneRegex, 'Phone number format must be 123-456-7890')
    .required('Phone number is required'),
  currentMileage: yup
    .string()
    .trim()
    .matches(mileageRegex, 'Current mileage must be number')
    .required('Current mileage is required'),
  reasonForArbitration: yup
    .string()
    .trim()
    .required('Reason is required')
    .max(4000, 'Reason cannot exceed 4000 characters')
})

export const initialArbitrationValues: IArbitrationForm = {
  name: '',
  email: '',
  phoneNumber: '',
  contactMethodID: 0,
  issueTypeID: 0,
  resolutionTypeID: 0,
  currentMileage: '',
  reasonForArbitration: '',
  documents: [] as IDocumentSubmit[]
}
